export default [
  {
    path: '/app/laboratory-educations',
    name: 'LaboratoryEducations',
    component: () => import('@/views/Admin/Laboratory_educations/Index.vue'),
    meta: {
      pageTitle: 'Laboratuvar',
      breadcrumb: [
        {
          text: 'Eğitimlerimiz',
          active: true,
        },
      ],
      resource: 'ADMIN_LAB',
      action: 'read',
    },
  },
  {
    path: '/app/laboratory-educations/add',
    name: 'LaboratoryEducationAdd',
    component: () => import('@/views/Admin/Laboratory_educations/Add.vue'),
    meta: {
      pageTitle: 'Laboratuvar',
      breadcrumb: [
        {
          text: 'Eğitimlerimiz',
          to: '/app/laboratory-educations',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_LAB',
      action: 'read',
    },
  },
  {
    path: '/app/laboratory-educations/edit/:id',
    name: 'LaboratoryEducationEdit',
    component: () => import('@/views/Admin/Laboratory_educations/Edit.vue'),
    meta: {
      pageTitle: 'Laboratuvar',
      breadcrumb: [
        {
          text: 'Eğitimlerimiz',
          to: '/app/laboratory-educations',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_LAB',
      action: 'read',
    },
  },
]
